import Vue from 'vue/dist/vue.min.js';
import EventBus from './event-bus';

const internalSearch = () => {

    let searchBar = document.querySelectorAll('.hero-center__search');

    let internalSearchConstructor = (id) => {
        Vue.component('internal-search', {
            data: function() {
                return {
                    value: window.softwareHasQuery ? window.softwareQuery : null,
                    type: null
                }
            },
            watch: {
                "value": function() {
                    if (this.value == "") {
                        //console.log("no value")
                        EventBus.$emit('internal-search', null, this.type);
                    }
                }
            },
            methods: {
                handleSubmit(e, type) {
                    let value = this.value;
                    // console.log(value);
                    // emit search query to documentation and software modules
                    EventBus.$emit('internal-search', value, type);
                }
            },
            mounted() {
                this.type = this.$refs.form.dataset.type;
                EventBus.$emit('internal-search', this.value, this.type);
            }
        });

        new Vue({
            el: `.internal-search-${id}`,
        }).$mount(`.internal-search-${id}`, true);
    };

    if (searchBar.length > 0) {
        searchBar.forEach((item, index) => {
            item.classList.add(`internal-search-${index}`);
            internalSearchConstructor(index);
        })
    }

}

export default internalSearch;